import { useClient, useMutation, useQuery } from '@weenat/client'
import { useIntl } from '@weenat/wintl'
import { Redirect } from 'app/routx-router'
import Logout from 'app/src/authentication/components/Logout'
import useToasts from 'app/src/hooks/useToasts'
import EmptyStateWithRipple from 'app/src/kit/empty-state/EmptyStateWithRipple'
import Icons from 'app/src/kit/Icons'
import InfoCard from 'app/src/kit/InfoCard'
import Link from 'app/src/kit/LinkComponent'
import SmartText from 'app/src/kit/SmartText'
import Text from 'app/src/kit/Text'
import { useLoginAs, useToken } from 'app/state'
import isNil from 'lodash-es/isNil'
import { useState } from 'react'

export const Component = () => {
  const client = useClient()
  const [loginAs] = useLoginAs()
  const [token] = useToken()
  const meRequest = useQuery(client.me.get({ loginAsEmail: loginAs?.email }), {
    refetchOnWindowFocus: true,
    staleTime: 1,
    enabled: !isNil(token)
  })
  const me = meRequest.data
  const { t } = useIntl()
  const { addSuccessToast, addErrorToast } = useToasts()
  const [sendVerificationEmail] = useMutation(client.auth.sendVerificationEmail(), {
    onSuccess: () => {
      addSuccessToast(
        t('auth.verify_email_sent', {
          email: me?.email ?? ''
        })
      )
    },
    onError: (e) => {
      const [error] = e.nonFieldErrors || []
      if (!isNil(error)) {
        addErrorToast(t('errors.unknown'))
      }
    }
  })
  const [hasClickedOnNotReceivedMail, setHasClickedOnNotReceivedMail] = useState(false)
  return !isNil(me) ? (
    me.isEmailVerified ? (
      <Redirect to='/verify-email/success' keepCurrentParams />
    ) : (
      <>
        <Text $fontSize='lg' $textAlign='center'>
          {t('auth.verify_email')}
        </Text>
        <div>
          <EmptyStateWithRipple
            tint={'primary.500'}
            Icon={Icons.MarkUnread}
            title={''}
            description={t('auth.verify_email_sent', { email: me.email })}
          >
            <Flex
              $flexDirection='column'
              $gap='md'
              $justifyContent='center'
              $alignItems='center'
              $mt='2xl'
            >
              <Text $textAlign='center' $fontSize='sm'>
                {t('auth.verify_email_not_received')}
              </Text>
              <Link
                href=''
                $underlined
                onPress={(e) => {
                  e?.preventDefault()
                  setHasClickedOnNotReceivedMail(true)
                  sendVerificationEmail({ email: me.email })
                }}
              >
                {t('auth.reset_password_resend')}
              </Link>
              {!isNil(loginAs) ? <Logout /> : null}
              {hasClickedOnNotReceivedMail ? (
                <InfoCard
                  $mt='2xl'
                  type='tip'
                  title={t('auth.verification_mail_not_found')}
                  message={<SmartText tkey='auth.verification_mail_not_found_seek' />}
                />
              ) : null}
            </Flex>
          </EmptyStateWithRipple>
        </div>
      </>
    )
  ) : null
}
export default Component
